import { all, call, fork, put, takeLeading } from "typed-redux-saga";
import { Action, addEditConfigurationDialogActions } from "./add-edit-configuration-dialog-store";
import { errorActions } from "src/components/error-viewer/error-store";
import { ConfiguratorService, Model_ConfiguratorProductGet, Shared_PictureResolutions, SystemPackageService } from "src/backend/openapi/v1";
import { getContactPerson, getCurrentCustomer } from "src/utils";
import { productDetailsActions } from "src/pages/product-details/product-details-store";
import { CACHE_KEYS } from "src/utils/constants";
import { getCache, saveCache } from "src/utils/cache-utils";

export function* getSystemPackages() {
  try {
    const result = yield* call(SystemPackageService.getApiV1SystemPackage);
    yield put(addEditConfigurationDialogActions.getSystemPackagesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(addEditConfigurationDialogActions.getSystemPackagesFail());
  }
}

export function* watchGetSystemPackages() {
  yield takeLeading(Action.GetSystemPackagesRequest, getSystemPackages);
}

export function* getProducts(action: ReturnType<typeof addEditConfigurationDialogActions.getProductsRequest>) {
  try {
    const currentCustomer = yield* getCurrentCustomer();

    const cacheKey = CACHE_KEYS.PRODUCTS(action.payload.projectId, JSON.stringify(action.payload.data));

    let result: Model_ConfiguratorProductGet[];

    const cachedResponse = yield* call(() => getCache(cacheKey));
    if (cachedResponse) {
      result = yield* call(() => cachedResponse.json() as unknown as Model_ConfiguratorProductGet[]);
    } else {
      result = yield* call(ConfiguratorService.postApiV1ConfiguratorProjectsGetProducts, action.payload.projectId, "", currentCustomer.customerId, "", action.payload.data);
      saveCache(cacheKey, result, { memory: true });
    }

    yield put(addEditConfigurationDialogActions.getProductsSuccess(result));

    // fetch images
    const productPictures = result.map(x => x.primaryProductPictureId).filter(x => !!x) as string[];
    yield put(
      productDetailsActions.getMultipleProductPicturesRequest(productPictures, Shared_PictureResolutions.Medium, (isSuccess, data) => {
        if (isSuccess && data) addEditConfigurationDialogActions.updateProductPictures(data);
      })
    );
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(addEditConfigurationDialogActions.getProductsFail());
  }
}

export function* watchgetProducts() {
  yield takeLeading(Action.GetProductsRequest, getProducts);
}

export function* createProjectLineItem(action: ReturnType<typeof addEditConfigurationDialogActions.createProjectLineItemRequest>) {
  try {
    const currentCustomer = yield* getCurrentCustomer();
    const contactPerson = yield* getContactPerson();

    if (!contactPerson.identityId) throw Error("Missing identity id");

    // It'll be always there but making eslint happy
    if (!action.payload.data.projectLineItemId) {
      // eslint-disable-next-line @itk/undesired-code-alerter
      console.error("Missing project line item id");
      throw Error("Something went wrong");
    }

    const result = yield* call(
      ConfiguratorService.putApiV1ConfiguratorProjectLineItemsCreate,
      action.payload.data.projectLineItemId,
      contactPerson.identityId,
      currentCustomer.customerId,
      undefined,
      action.payload.data
    );
    action.payload.callBack(true, result);
  } catch (error) {
    yield put(errorActions.addError(error));
    action.payload.callBack(false);
  }
}

export function* watchcreateProjectLineItem() {
  yield takeLeading(Action.CreateProjectLineItemRequest, createProjectLineItem);
}

export function* addEditConfigurationDialogSaga() {
  yield all([fork(watchGetSystemPackages), fork(watchgetProducts), fork(watchcreateProjectLineItem)]);
}
